<template>
    <transition name="modal-animation" @click.self="close">
      <div v-show="modalActive" class="modal z-50 w-full font-outfit">
        <transition name="modal-animation-inner">
          <div v-show="modalActive" class="modal-inner md:w-1/2 shadow-lg rounded-lg">
            
            <slot />
          </div>
        </transition>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    props: ["modalActive"],
    setup(props, { emit }) {
  
      const close = () => {
        emit("close");
      };
  
      return { close };
    },
  
    mounted() {},
  };
  </script>
  
  <style scoped>
  .modal-animation-enter-active,
  .modal-animation-leave-active {
    transition: opacity 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
  }
  
  .modal-animation-enter-from,
  .modal-animation-leave-to {
    opacity: 0;
  }
  
  .modal-animation-inner-enter-active {
    transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02) 0.15s;
  }
  
  .modal-animation-inner-leave-active {
    transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
  }
  
  .modal-animation-inner-enter-from {
    opacity: 0;
    transform: scale(0.8);
  }
  
  .modal-animation-inner-leave-to {
    transform: scale(0.8);
  }
  
  .modal {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
  
    background-color: rgba(0, 0, 0, 0.8);
  }
  
  .modal-inner {
    position: relative;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
    background-color: #f1f3f8;
    padding: 32px 16px;
  }
  </style>
  